/**
 * Legalbus COP REST API 1.0
 * REST API for the Legalbus COP digital signature platform
 *
 * The version of the OpenAPI document: 2.30.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Liveness } from './liveness';
import { ProcessData } from './processData';


export interface LivenessStatusResponse { 
    status?: Liveness;
    process?: ProcessData;
    docCaptureStatus?: LivenessStatusResponse.DocCaptureStatusEnum;
}
export namespace LivenessStatusResponse {
    export type DocCaptureStatusEnum = 'IN_PROGRESS' | 'OCR_COMPLETED' | 'COMPLETED' | 'COMPLETED_WITH_WARNINGS' | 'INVALID' | 'FAILED';
    export const DocCaptureStatusEnum = {
        InProgress: 'IN_PROGRESS' as DocCaptureStatusEnum,
        OcrCompleted: 'OCR_COMPLETED' as DocCaptureStatusEnum,
        Completed: 'COMPLETED' as DocCaptureStatusEnum,
        CompletedWithWarnings: 'COMPLETED_WITH_WARNINGS' as DocCaptureStatusEnum,
        Invalid: 'INVALID' as DocCaptureStatusEnum,
        Failed: 'FAILED' as DocCaptureStatusEnum
    };
}


